




























































































































// decoradores
import { Vue, Component } from "vue-property-decorator";
// vuex
import { mapActions, mapGetters } from "vuex";
// tipos

// componentes
import TablaCliente from "@/components/clientes/Tabla.vue";
import FormularioCliente from "@/components/clientes/Formulario.vue";
import { DataFormularioCliente } from "@/typings/components/clientes/formulario";
import DialogoExito from "@/components/DialogoExito.vue";
import DialogoEliminar from "@/components/DialogoEliminar.vue";
import InfoCliente from "@/components/clientes/Info.vue";
//import BotonesCrud from "@/components/BotonesCrud.vue";
import MensajeEliminar from "@/components/MensajeEliminar.vue";
//import TituloVista from "@/components/TituloVista.vue";
import {
  Cliente,
  Clientes,
  //  Regiones,
} from "@/typings/store/plugins/easyFirestore/clientes";
//import { DataFormularioRegion } from "@/typings/components/regiones/formulario";
import CargarClientesExcel from "@/components/excel/CargarClientes.vue";
import ExportarExcelGenerico from "@/components/ExportarExcelGenerico.vue";
import ExportarPdfGenerico from "@/components/ExportarPdfGenerico.vue";

const routeGuard = (vm: Vue): boolean => {
  const permisos = vm.getUsuario?.permisos;
  if (permisos && permisos["clientes"]) {
    return true;
  }

  const rutas = vm.getRutasUsuario;
  if (rutas.length > 0) {
    const to = rutas[0].to;
    if (to) {
      if (vm.$route.name !== to.name) {
        vm.$router.replace(to);
      }
      return false;
    }
  }
  if (vm.$route.name !== "inicio") {
    vm.$router.replace({ name: "inicio" });
  }
  return false;
};

@Component({
  computed: mapGetters({
    getUsuarios: "usuarios/get",
    getClientes: "clientes/get",
    getArrayUsuarios: "usuarios/getArray",
    getUsuario: "usuario/get",
    getRutas: "rutas/get",
    getRutasUsuario: "usuario/getRutas",
    getArrayClientes: "clientes/getArray",
  }),
  methods: mapActions({
    setCliente: "clientes/set",
    deleteCliente: "clientes/delete",
    insertBatchCliente: "clientes/insertBatch",
    //setArchivo: "archivos/set",
    //deleteArchivo: "archivos/delete",
  }),
  beforeRouteEnter(to, from, next) {
    next(routeGuard);
  },
  components: {
    DialogoEliminar,
    DialogoExito,
    TablaCliente,
    FormularioCliente,
    InfoCliente,
    MensajeEliminar,
    CargarClientesExcel,
    ExportarExcelGenerico,
    ExportarPdfGenerico,
  },
})
export default class VistaClientes extends Vue {
  created(): void {
    if (!routeGuard(this)) {
      return;
    }
  }

  cargando = false;
  dialogoExito = {
    model: false,
    texto: "",
    icono: "",
  };
  search = "";
  cliente: Cliente | null = null;
  dialogoInfo = false;
  dialogoFormulario = false;
  dialogoEliminar = false;
  textoEliminar = "¿ESTÁS SEGURO QUE DESEAS ELIMINAR ESTE CLIENTE?";
  dialogoCargarExcel = false;

  get clientes(): Clientes {
    return this.getClientes;
  }

  get items(): Array<Cliente> {
    return (
      this.getArrayClientes
        // ordenar por codigo
        .sort((a, b) => {
          if (a.codigo < b.codigo) {
            return -1;
          } else if (a.codigo > b.codigo) {
            return 1;
          }
          return 0;
        })
    );
  }

  get columnasExportacionClientes(): Array<{ label: string; field: string }> {
    return [
      { label: "Código", field: "codigo" },
      { label: "Nombre", field: "nombre" },
      { label: "RUT", field: "rut" },
      { label: "Giro", field: "giro" },
      { label: "Teléfono", field: "telefono" },
      { label: "Correo", field: "correo" },
    ];
  }

  clickItem(val: { id: string } | null): void {
    this.cliente = val ? this.clientes[val.id] : null;
  }

  clickPlus(): void {
    this.cliente = null;
    this.dialogoFormulario = true;
  }

  async clickGuardar(data: DataFormularioCliente): Promise<void> {
    this.cargando = true;
    const doc = data.doc;
    await this.setCliente(doc);
    if (doc.id != this.cliente?.id) {
      this.dialogoExito = {
        model: true,
        texto: "¡Cliente creado con éxito!",
        icono: require("../assets/icons/double-check-duo.svg"),
      };
    }
    if (doc.id == this.cliente?.id) {
      this.dialogoExito = {
        model: true,
        texto: "¡Cliente editado con éxito!",
        icono: require("../assets/icons/editar.svg"),
      };
      this.cliente = doc;
    }
    this.cerrarDialogoFormulario();
    this.cargando = false;
  }

  cerrarDialogoExito(): void {
    this.dialogoExito = {
      model: false,
      texto: "",
      icono: "",
    };
  }

  clickEliminar(): void {
    const cliente = this.cliente;
    if (!cliente?.id) {
      console.error("error id: ", cliente);
      return;
    }
    this.deleteCliente(cliente.id);
    this.cliente = null;
    this.cerrarDialogoEliminar();
  }

  abrirDialogoInfo(cliente: Cliente): void {
    if (!cliente.id) {
      console.error("error id: ", cliente);
      return;
    }
    const doc = this.clientes[cliente.id];
    if (doc) {
      this.cliente = doc;
      this.dialogoInfo = true;
    }
  }

  cerrarDialogoInfo(): void {
    this.dialogoInfo = false;
    this.cliente = null;
  }

  abrirDialogoFormulario(cliente: Cliente): void {
    if (!cliente.id) {
      console.error("error id: ", cliente);
      return;
    }
    const doc = this.clientes[cliente.id];
    if (doc) {
      this.cliente = doc;
      this.dialogoFormulario = true;
    }
  }

  abrirDialogoEliminar(cliente: Cliente): void {
    if (!cliente.id) {
      console.error("error id: ", cliente);
      return;
    }
    const doc = this.clientes[cliente.id];
    if (doc) {
      this.dialogoEliminar = true;
      this.cliente = doc;
    }
  }

  cerrarDialogoEliminar(): void {
    this.dialogoEliminar = false;
    this.cliente = null;
  }

  cerrarDialogoFormulario(): void {
    this.dialogoFormulario = false;
    this.cliente = null;
  }
}
